import { toggleAllInputsInContainer } from '@js/utilities/toggleInputsInContainer';

const showReturnsContainer = () => {
    const returnsContainer = document.querySelector('#returns-form-container');
    const servicesContainer = document.querySelector('#services-container');

    returnsContainer.classList.remove('d-none');
    servicesContainer.classList.add('d-none');
};

const returnTypeContentToggler = (returnType) => {
    const returnTypeElements = [...document.querySelectorAll('.js-returns-form-type-content')];

    returnTypeElements.forEach((el) => {
        el.classList.add('d-none');
        toggleAllInputsInContainer(el, false);
    });

    returnTypeElements
        .filter((el) => el.dataset.serviceType?.includes(returnType))
        .forEach((el) => {
            el.classList.remove('d-none');
            toggleAllInputsInContainer(el, true);
        });
};

const updateFormInputReturnType = (returnType) => {
    const formInputReturnTypeInput = document.querySelector('.js-return-type-input');

    formInputReturnTypeInput.value = returnType;
};

export const returnTypeListener = () => {
    const setReturnTypeElements = document.querySelectorAll('.js-set-return-type');

    setReturnTypeElements.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();

            window.dispatchEvent(
                new CustomEvent('return-type-set', {
                    detail: { returnType: el.dataset.serviceType },
                })
            );
        });
    });

    window.addEventListener('return-type-set', (e) => {
        const { returnType } = e.detail;

        returnTypeContentToggler(returnType);
        updateFormInputReturnType(returnType);
        showReturnsContainer();
        window.returnsFormData.serviceType = returnType;
    });

    window.addEventListener('RemoteContentLoaded', () => {
        returnTypeContentToggler(window.returnsFormData.serviceType);
        updateFormInputReturnType(window.returnsFormData.serviceType);
        // showReturnsContainer();
    });
};
